export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15008.1dffc27c.jpg";